import { IMposWebPortalApi } from "./IMposWebPortalApi";
import { ITerminalsDto } from "../../models/TerminalsDto";
import { Observable, Subscriber } from 'rxjs'
import { httpRestClient } from "../network/HttpRestClient";
import { ISuperUserDto } from "../../models/SuperUserDto";
import { IUsersDto } from "../../models/UsersDto";
import { IDevelopersDto } from "../../models/DevelopersDto";
import { MockApi } from "./MockApi";
import { IAddUserRequest } from "../../models/AddUserRequest";
import { IAddUserResponse } from "../../models/AddUserResponse";
import { sessionStorageInstance } from "../storage/Storage";
import { IUserDetailsDto } from "../../models/UserDetailsDto";
import { IDeveloperDetailsDto } from "../../models/DeveloperDetailsDto";
import { IUpdateUserRequestDto } from "../../models/UpdateUserDetails";
import { ITerminalUpdateOrRemoveDto } from "../../models/TerminalUpdateOrRemove";
import { IGetTCRequest } from "../../models/GetTCRequest";
import { IGetTCResponse } from "../../models/GetTCResponse";
import { IUpdateTCRequest } from "../../models/UpdateTCRequest";
import { GoogleTagManagerService } from "../analitycs/GoogleTagManagerService";
import { ConfigProvider } from "../configuration/ConfigProvider";
import { ICategoriesDto } from "../../models/CategoriesDto";
import { ICatalogDto } from "../../models/CatalogDto";
import { ICategoryDto } from "../../models/CategoryDto";
import { IProductsDto } from "../../models/ProductsDto";
import { IDuplicateCategoryRequest } from "../../models/DuplicateCategoryRequest";
import { IProductDto } from "../../models/ProductDto";
import { IProductDetailDto } from "../../models/ProductDetailDto";
import { IAddOrRemoveProductFromCategory } from "../../models/AddOrRemoveProductFromCategory";
import { IUpdateProductCategoriesDto } from "../../models/UpdateProductCategoriesDto";
import { IFileResponse } from "../../models/FileResponse";
import { IUploadFileRequest } from "../../models/UploadFileRequest";
import { IUploadFileResponse } from "../../models/UploadFileResponse";
import { HTTPResponses } from "../../models/HTTPResponses";
import { IMerchantsDto } from "../../models/MerchantsDto";
import { IApplicationsDto } from "../../models/ApplicationsDto";
import { IApplicationDetailDto } from "../../models/ApplicationDetailsDto";

export class MposWebPortalApi implements IMposWebPortalApi {
  private config: any = null;
  private static instance: MposWebPortalApi;
  private constructor() {
    this.config = ConfigProvider.getInstance().getConfiguration();
  }

  public static getInstance(): MposWebPortalApi {
    if (!MposWebPortalApi.instance) {
      MposWebPortalApi.instance = new MposWebPortalApi();
    }

    return MposWebPortalApi.instance;
  }

  getTerminals(): Observable<ITerminalsDto> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().getTerminals();
    } else {
      // @ts-ignore
      let url = this.config.baseApi + this.config.endpoints.getTerminals;
      return new Observable((subscriber: Subscriber<ITerminalsDto>) => {
        httpRestClient.get(url).subscribe((response) => {
          if (response.status === 200) {
            let data = response.data;
            subscriber.next(data)
          } else {
            subscriber.error(response);
            // Send analytics
            GoogleTagManagerService.getInstance().pushGenericError('In questo momento il sito non è disponibile.',
              response.status !== undefined ? response.status.toString() : '-1000',
              response.statusText !== undefined ? response.statusText : 'Generic error'
            );
          }
        }, (error) => {
          subscriber.error(error);
          // Send analytics
          GoogleTagManagerService.getInstance().pushGenericError('In questo momento il sito non è disponibile.',
            error.status !== undefined ? error.status.toString() : '-1000',
            error.statusText !== undefined ? error.statusText : 'Generic error'
          );
        });
      });
    }
  }

  getSuperUserDetails(): Observable<ISuperUserDto> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().getSuperUserDetails();
    } else {
      // @ts-ignore
      let url = this.config.baseApi + this.config.endpoints.superUserDetail;
      return new Observable((subscriber: Subscriber<ISuperUserDto>) => {
        httpRestClient.get(url).subscribe((response) => {
          if (response.status === 200) {
            let data = response.data;
            sessionStorageInstance.setData('user', data);
            subscriber.next(data)
          } else {
            subscriber.error(response);
            // Send analytics
            GoogleTagManagerService.getInstance().pushGenericError('In questo momento il sito non è disponibile.',
              response.status !== undefined ? response.status.toString() : '-1000',
              response.statusText !== undefined ? response.statusText : 'Generic error'
            );
          }
        }, (error) => {
          subscriber.error(error);
          // Send analytics
          GoogleTagManagerService.getInstance().pushGenericError('In questo momento il sito non è disponibile.',
            error.status !== undefined ? error.status.toString() : '-1000',
            error.statusText !== undefined ? error.statusText : 'Generic error'
          );
        });
      });
    }
  }

  getUsers(): Observable<IUsersDto> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().getUsers();
    } else {
      // @ts-ignore
      let url = this.config.baseApi + this.config.endpoints.getUsers;
      return new Observable((subscriber: Subscriber<IUsersDto>) => {
        httpRestClient.get(url).subscribe((response) => {
          if (response.status === 200) {
            let data = response.data;
            subscriber.next(data)
          } else {
            // Send analytics
            GoogleTagManagerService.getInstance().pushGenericError('In questo momento il sito non è disponibile.',
              response.status !== undefined ? response.status.toString() : '-1000',
              response.statusText !== undefined ? response.statusText : 'Generic error'
            );
          }
        }, (error) => {
          subscriber.error(error);
          // Send analytics
          GoogleTagManagerService.getInstance().pushGenericError('In questo momento il sito non è disponibile.',
            error.status !== undefined ? error.status.toString() : '-1000',
            error.statusText !== undefined ? error.statusText : 'Generic error'
          );
        });
      });
    }
  }

  addUser(request: IAddUserRequest): Observable<IAddUserResponse> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().addUser(request);
    } else {
      // @ts-ignore
      let url = this.config.baseApi + this.config.endpoints.addUser;
      return new Observable((subscriber: Subscriber<IAddUserResponse>) => {
        httpRestClient.post(url, request).subscribe((response) => {
          if (response.status === 200) {
            let data = response.data;
            subscriber.next(data)
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  userDetails(username: string): Observable<IUserDetailsDto> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().userDetails(username);
    } else {
      // @ts-ignore
      let url = this.config.baseApi + this.config.endpoints.detailUser;
      return new Observable((subscriber: Subscriber<IUserDetailsDto>) => {
        httpRestClient.get(url, { username: username }).subscribe((response) => {
          if (response.status === 200) {
            let data = response.data;
            subscriber.next(data)
          } else {
            subscriber.error(response);
            // Send analytics
            GoogleTagManagerService.getInstance().pushGenericError('In questo momento il sito non è disponibile.',
              response.status !== undefined ? response.status.toString() : '-1000',
              response.statusText !== undefined ? response.statusText : 'Generic error'
            );
          }
        }, (error) => {
          subscriber.error(error);
          // Send analytics
          GoogleTagManagerService.getInstance().pushGenericError('In questo momento il sito non è disponibile.',
            error.status !== undefined ? error.status.toString() : '-1000',
            error.statusText !== undefined ? error.statusText : 'Generic error'
          );
        });
      });
    }
  }

  deleteUser(username: string): Observable<boolean> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().deleteUser(username);
    } else {
      // @ts-ignore
      let url = this.config.baseApi + this.config.endpoints.deleteUser;
      return new Observable((subscriber: Subscriber<boolean>) => {
        httpRestClient.delete(url, { username: username }).subscribe((response) => {
          if (response.status === 200) {
            let data = true;
            subscriber.next(data)
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  resetPassword(username: string, mail: string): Observable<boolean> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().deleteUser(username);
    } else {
      // @ts-ignore
      let url = this.config.baseApi + this.config.endpoints.resetPwd;
      return new Observable((subscriber: Subscriber<boolean>) => {
        httpRestClient.get(url, { username: username, mail: mail }).subscribe((response) => {
          if (response.status === 200) {
            let data = true;
            subscriber.next(data)
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  updateUserDetails(request: IUpdateUserRequestDto): Observable<boolean> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().updateUserDetails(request);
    } else {
      // @ts-ignore
      let url = this.config.baseApi + this.config.endpoints.updateUserDetails;
      return new Observable((subscriber: Subscriber<boolean>) => {
        httpRestClient.post(url, request).subscribe((response) => {
          if (response.status === 200) {
            let data = true;
            subscriber.next(data)
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  updateTerminalToUser(request: ITerminalUpdateOrRemoveDto): Observable<boolean> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().updateTerminalToUser(request);
    } else {
      // @ts-ignore
      let url = this.config.baseApi + this.config.endpoints.updateTerminalToUser;
      return new Observable((subscriber: Subscriber<boolean>) => {
        httpRestClient.post(url, request).subscribe((response) => {
          if (response.status === 200) {
            let data = true;
            subscriber.next(data)
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  removeTerminalToUser(request: ITerminalUpdateOrRemoveDto): Observable<boolean> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().removeTerminalToUser(request);
    } else {
      // @ts-ignore
      let url = this.config.baseApi + this.config.endpoints.removeTerminalToUser;
      return new Observable((subscriber: Subscriber<boolean>) => {
        httpRestClient.post(url, request).subscribe((response) => {
          if (response.status === 200) {
            let data = true;
            subscriber.next(data)
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  getTCStatus(request: IGetTCRequest): Observable<IGetTCResponse> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().getTCStatus(request);
    } else {
      // @ts-ignore
      let url = this.config.baseApi + this.config.endpoints.getTCStatus;
      return new Observable((subscriber: Subscriber<IGetTCResponse>) => {
        httpRestClient.post(url, request).subscribe((response) => {
          if (response.status === 200) {
            let data = response.data;
            subscriber.next(data)
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  updateTCStatus(request: IUpdateTCRequest): Observable<boolean> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().updateTCStatus(request);
    } else {
      // @ts-ignore
      let url = this.config.baseApi + this.config.endpoints.updateTCStatus;
      return new Observable((subscriber: Subscriber<boolean>) => {
        httpRestClient.post(url, request).subscribe((response) => {
          if (response.status === 200) {
            let data = true;
            subscriber.next(data)
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  getCatalog(): Observable<ICatalogDto> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().getCatalog();
    } else {
      let url = this.config.baseApi + this.config.endpoints.getCatalog;
      return new Observable((subscriber: Subscriber<ICatalogDto>) => {
        httpRestClient.get(url).subscribe((response) => {
          if (response.status === 200) {
            let data = response.data;
            subscriber.next(data)
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  addCategory(request: ICategoriesDto): Observable<boolean> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().addCategory(request);
    } else {
      let url = this.config.baseApi + this.config.endpoints.category;
      return new Observable((subscriber: Subscriber<boolean>) => {
        httpRestClient.post(url, request).subscribe((response) => {
          if (response.status === 200) {
            subscriber.next(true);
          } else {
            subscriber.next(false)
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  updateCategory(request: ICategoryDto): Observable<boolean> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().updateCategory(request);
    } else {
      let url = this.config.baseApi + this.config.endpoints.category + '/' + request.categoryId;
      return new Observable((subscriber: Subscriber<boolean>) => {
        httpRestClient.put(url, request).subscribe((response) => {
          if (response.status === 200) {
            subscriber.next(true)
          } else {
            subscriber.next(false)
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  deleteCategory(request: ICategoryDto): Observable<boolean> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().deleteCategory(request);
    } else {
      let url = this.config.baseApi + this.config.endpoints.category + '/' + request.categoryId;
      return new Observable((subscriber: Subscriber<boolean>) => {
        httpRestClient.delete(url).subscribe((response) => {
          if (response.status === 200) {
            subscriber.next(true)
          } else {
            subscriber.next(false)
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  getProductsForCategory(id: string): Observable<IProductsDto> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().getProductsForCategory(id);
    } else {
      let url = this.config.baseApi + this.config.endpoints.product + '/' + id;
      return new Observable((subscriber: Subscriber<IProductsDto>) => {
        httpRestClient.get(url).subscribe((response) => {
          if (response.status === 200) {
            let data = response.data;
            subscriber.next(data);
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  copyCategory(request: IDuplicateCategoryRequest): Observable<any> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().copyCategory(request);
    } else {
      let url = this.config.baseApi + this.config.endpoints.category + '/duplicate';
      return new Observable((subscriber: Subscriber<any>) => {
        httpRestClient.post(url, request).subscribe((response) => {
          if (response.status === 200) {
            subscriber.next(response);
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  deleteProduct(request: IProductDto): Observable<boolean> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().deleteProduct(request);
    } else {
      let url = this.config.baseApi + this.config.endpoints.product + '/' + request.productId;
      return new Observable((subscriber: Subscriber<boolean>) => {
        httpRestClient.delete(url).subscribe((response) => {
          if (response.status === 200) {
            subscriber.next(true);
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  getCategories(): Observable<ICategoriesDto> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().getCategories();
    } else {
      let url = this.config.baseApi + this.config.endpoints.category
      return new Observable((subscriber: Subscriber<ICategoriesDto>) => {
        httpRestClient.get(url).subscribe((response) => {
          if (response.status === 200) {
            subscriber.next(response.data);
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  addProduct(request: IProductsDto): Observable<boolean> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().addProduct(request);
    } else {
      let url = this.config.baseApi + this.config.endpoints.product
      return new Observable((subscriber: Subscriber<boolean>) => {
        httpRestClient.post(url, request).subscribe((response) => {
          if (response.status === 200) {
            subscriber.next(true);
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  updateProduct(request: IProductDto): Observable<boolean> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().updateProduct(request);
    } else {
      let url = this.config.baseApi + this.config.endpoints.product + '/' + request.productId;
      return new Observable((subscriber: Subscriber<boolean>) => {
        httpRestClient.put(url, request).subscribe((response) => {
          if (response.status === 200) {
            subscriber.next(true);
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  getProduct(id: string): Observable<IProductDetailDto> {
    if (this.config.mockData) {
      return MockApi.getInstance().getProduct(id);
    } else {
      let url = this.config.baseApi + this.config.endpoints.product + '/' + id + '/details';
      return new Observable((subscriber: Subscriber<IProductDetailDto>) => {
        httpRestClient.get(url).subscribe((response) => {
          if (response.status === 200) {
            subscriber.next(response.data);
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  removeProductsFromCategory(request: IAddOrRemoveProductFromCategory): Observable<boolean> {
    if (this.config.mockData) {
      return MockApi.getInstance().removeProductsFromCategory(request);
    } else {
      let url = this.config.baseApi + this.config.endpoints.category + '/removeProducts';
      return new Observable((subscriber: Subscriber<boolean>) => {
        httpRestClient.post(url, request).subscribe((response) => {
          if (response.status === 200) {
            subscriber.next(true);
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  addProductsToCategory(request: IAddOrRemoveProductFromCategory): Observable<boolean> {
    if (this.config.mockData) {
      return MockApi.getInstance().removeProductsFromCategory(request);
    } else {
      let url = this.config.baseApi + this.config.endpoints.category + '/addProducts';
      return new Observable((subscriber: Subscriber<boolean>) => {
        httpRestClient.post(url, request).subscribe((response) => {
          if (response.status === 200) {
            subscriber.next(true);
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  getProducts(): Observable<IProductsDto> {
    if (this.config.mockData) {
      return MockApi.getInstance().getProducts();
    } else {
      let url = this.config.baseApi + this.config.endpoints.product;
      return new Observable((subscriber: Subscriber<IProductsDto>) => {
        httpRestClient.get(url).subscribe((response) => {
          if (response.status === 200) {
            subscriber.next(response.data);
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  updateProductCategories(id: string, request: IUpdateProductCategoriesDto): Observable<IProductDto> {
    if (this.config.mockData) {
      return MockApi.getInstance().updateProductCategories(id, request);
    } else {
      let url = this.config.baseApi + this.config.endpoints.product + '/' + id + '/updateCategories';
      return new Observable((subscriber: Subscriber<IProductDto>) => {
        httpRestClient.post(url, request).subscribe((response) => {
          if (response.status === 200) {
            subscriber.next(response.data);
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  getCatalogFile(): Observable<IFileResponse> {
    if (this.config.mockData) {
      return MockApi.getInstance().getCatalogFile();
    } else {
      let url = this.config.baseApi + this.config.endpoints.file + '/product';
      return new Observable((subscriber: Subscriber<IFileResponse>) => {
        httpRestClient.get(url).subscribe((response) => {
          if (response.status === 200) {
            subscriber.next(response.data);
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  getTemplateFile(): Observable<IFileResponse> {
    if (this.config.mockData) {
      return MockApi.getInstance().getTemplateFile();
    } else {
      let url = this.config.baseApi + this.config.endpoints.file + '/template';
      return new Observable((subscriber: Subscriber<IFileResponse>) => {
        httpRestClient.get(url).subscribe((response) => {
          if (response.status === 200) {
            subscriber.next(response.data);
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  uploadFile(request: IUploadFileRequest): Observable<IUploadFileResponse> {
    if (this.config.mockData) {
      return MockApi.getInstance().uploadFile(request);
    } else {
      let url = this.config.baseApi + this.config.endpoints.file + '/product';
      return new Observable((subscriber: Subscriber<IUploadFileResponse>) => {
        httpRestClient.post(url, request).subscribe((response) => {
          if (response.status === 200) {
            subscriber.next(response.data);
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  getApps(request: any): Observable<IApplicationsDto> {
    if (this.config.mockData) {
      return MockApi.getInstance().getApps(request);
    } else {
      // @ts-ignore
      let url = this.config.baseApi + this.config.endpoints.getApps;
      return new Observable((subscriber: Subscriber<IApplicationsDto>) => {
        httpRestClient.post(url, request).subscribe((response) => {
          if (response.status === 200) {
            let data = response.data;
            subscriber.next(data)
          } else {
            subscriber.error(response);
            // Send analytics
            // GoogleTagManagerService.getInstance().pushGenericError('In questo momento il sito non è disponibile.',
            //     response.status !== undefined ? response.status.toString() : '-1000',
            //     response.statusText !== undefined ? response.statusText : 'Generic error'
            // );
          }
        }, (error) => {
          subscriber.error(error);
          // Send analytics
          // GoogleTagManagerService.getInstance().pushGenericError('In questo momento il sito non è disponibile.',
          //     error.status !== undefined ? error.status.toString() : '-1000',
          //     error.statusText !== undefined ? error.statusText : 'Generic error'
          // );
        });
      });
    }
  }

  deleteApp(appId: string | null): Observable<HTTPResponses> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().deleteApp(appId);
    } else {
      let url = this.config.baseApi + this.config.endpoints.deleteApp + appId;
      return new Observable((subscriber: Subscriber<HTTPResponses>) => {
        httpRestClient.delete(url).subscribe((response) => {
          if (response.status === 200) {
            subscriber.next(HTTPResponses.OK)
          } else if (response.status === 400) {
            subscriber.error(HTTPResponses.NOT_FOUND);
          }
          else {
            subscriber.error(HTTPResponses.KO);
          }
        }, (error) => {
          subscriber.error(HTTPResponses.KO);
        });
      });
    }
  }

  addMerchantsToApp(request: any): Observable<HTTPResponses> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().addMerchantsToApp(request);
    } else {
      let url = this.config.baseApi + this.config.endpoints.addMerchantsToApp;
      return new Observable((subscriber: Subscriber<HTTPResponses>) => {
        httpRestClient.post(url, request).subscribe((response) => {
          if (response.status === 200) {
            subscriber.next(HTTPResponses.OK)
          } else if (response.status === 400) {
            subscriber.error(HTTPResponses.NOT_FOUND);
          }
          else {
            subscriber.error(HTTPResponses.KO);
          }
        }, (error) => {
          subscriber.error(HTTPResponses.KO);
        });
      });
    }
  }

  removeMerchantFromApp(request: any): Observable<HTTPResponses> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().removeMerchantFromApp(request);
    } else {
      let url = this.config.baseApi + this.config.endpoints.removeMerchantFromApp;
      return new Observable((subscriber: Subscriber<HTTPResponses>) => {
        httpRestClient.post(url, request).subscribe((response) => {
          if (response.status === 200) {
            subscriber.next(HTTPResponses.OK)
          } else if (response.status === 400) {
            subscriber.error(HTTPResponses.NOT_FOUND);
          } else if (response.status === 401) {
            subscriber.error(HTTPResponses.NOT_FOUND);
          }
          else {
            subscriber.error(HTTPResponses.KO);
          }
        }, (error) => {
          subscriber.error(HTTPResponses.KO);
        });
      });
    }
  }

  searchMerchant(request: any): Observable<IMerchantsDto> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().searchMerchant(request);
    } else {
      let url = this.config.baseApi + this.config.endpoints.searchMerchant;
      return new Observable((subscriber: Subscriber<IMerchantsDto>) => {
        httpRestClient.post(url, request).subscribe((response) => {
          if (response.status === 200) {
            let data = response.data;
            subscriber.next(data)
          } else {
            subscriber.error(response);
            // Send analytics
            // GoogleTagManagerService.getInstance().pushGenericError('In questo momento il sito non è disponibile.',
            //     response.status !== undefined ? response.status.toString() : '-1000',
            //     response.statusText !== undefined ? response.statusText : 'Generic error'
            // );
          }
        }, (error) => {
          subscriber.error(error);
          // Send analytics
          // GoogleTagManagerService.getInstance().pushGenericError('In questo momento il sito non è disponibile.',
          //     error.status !== undefined ? error.status.toString() : '-1000',
          //     error.statusText !== undefined ? error.statusText : 'Generic error'
          // );
        });
      });
    }
  }

  addDeveloper(email: string): Observable<HTTPResponses> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().addDeveloper(email);
    } else {
      // @ts-ignore
      let url = this.config.baseApi + this.config.endpoints.addDeveloper;
      let body = {
        "email": email
      }
      return new Observable((subscriber: Subscriber<HTTPResponses>) => {
        httpRestClient.post(url, body).subscribe((response) => {
          if (response.status === 200) {
            subscriber.next(HTTPResponses.OK)
          } else if (response.status === 400) {
            subscriber.error(HTTPResponses.NOT_FOUND);
          }
          else {
            subscriber.error(HTTPResponses.KO);
          }
        }, (error) => {
          if (error.status === 400 && /already/.test(error.data.message)) {
            subscriber.next(HTTPResponses.ALREADY_PRESENT);
          }
          else if (error.status === 404 && /not found/.test(error.data.message)) {
            subscriber.next(HTTPResponses.NOT_FOUND);
          } else {
            subscriber.error(HTTPResponses.KO);
          }
        });
      });
    }
  }

  getDevelopers(): Observable<IDevelopersDto> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().getDevelopers();
    } else {
      // @ts-ignore
      let url = this.config.baseApi + this.config.endpoints.getDevelopers;
      return new Observable((subscriber: Subscriber<IDevelopersDto>) => {
        httpRestClient.get(url).subscribe((response) => {
          if (response.status === 200) {
            let data = response.data;
            subscriber.next(data)
          } else {
            // Send analytics
            GoogleTagManagerService.getInstance().pushGenericError('In questo momento il sito non è disponibile.',
              response.status !== undefined ? response.status.toString() : '-1000',
              response.statusText !== undefined ? response.statusText : 'Generic error'
            );
          }
        }, (error) => {
          subscriber.error(error);
          // Send analytics
          GoogleTagManagerService.getInstance().pushGenericError('In questo momento il sito non è disponibile.',
            error.status !== undefined ? error.status.toString() : '-1000',
            error.statusText !== undefined ? error.statusText : 'Generic error'
          );
        });
      });
    }
  }

  detailDeveloper(devId: string): Observable<IDeveloperDetailsDto> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().developerDetails(devId);
    } else {
      // @ts-ignore
      let url = this.config.baseApi + this.config.endpoints.detailDeveloper;
      return new Observable((subscriber: Subscriber<IDeveloperDetailsDto>) => {
        httpRestClient.get(url, { devId: devId }).subscribe((response) => {
          if (response.status === 200) {
            let data = response.data;
            subscriber.next(data)
          } else {
            subscriber.error(response);
            // Send analytics
            GoogleTagManagerService.getInstance().pushGenericError('In questo momento il sito non è disponibile.',
              response.status !== undefined ? response.status.toString() : '-1000',
              response.statusText !== undefined ? response.statusText : 'Generic error'
            );
          }
        }, (error) => {
          subscriber.error(error);
          // Send analytics
          GoogleTagManagerService.getInstance().pushGenericError('In questo momento il sito non è disponibile.',
            error.status !== undefined ? error.status.toString() : '-1000',
            error.statusText !== undefined ? error.statusText : 'Generic error'
          );
        });
      });
    }
  }

  removeDeveloper(email: string): Observable<HTTPResponses> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().removeDeveloper(email);
    } else {
      // @ts-ignore
      let url = this.config.baseApi + this.config.endpoints.removeDeveloper;
      let body = {
        email: email
      }
      return new Observable((subscriber: Subscriber<HTTPResponses>) => {
        httpRestClient.post(url, body).subscribe((response) => {
          if (response.status === 200) {
            subscriber.next(HTTPResponses.OK)
          } else {
            subscriber.error(HTTPResponses.KO);
          }
        }, (error) => {
          subscriber.error(HTTPResponses.KO);
        });
      });
    }
  }

  getMerchants(): Observable<IMerchantsDto> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().getMerchants();
    } else {
      // @ts-ignore
      let url = this.config.baseApi + this.config.endpoints.getMerchants;
      return new Observable((subscriber: Subscriber<IMerchantsDto>) => {
        httpRestClient.get(url).subscribe((response) => {
          if (response.status === 200) {
            let data = response.data;
            subscriber.next(data)
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(HTTPResponses.KO);
        });
      });
    }
  }

  createApp(appName: string | null, merchants: string[] | null, redirect_uri: string | null): Observable<HTTPResponses> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().createApp(appName, merchants, redirect_uri);
    } else {
      let url = this.config.baseApi + this.config.endpoints.createApp;
      let body = {
        appName: appName,
        merchants: merchants,
        redirect_uri: redirect_uri
      }
      return new Observable((subscriber: Subscriber<HTTPResponses>) => {
        httpRestClient.post(url, body).subscribe((response) => {
          if (response.status === 200) {
            subscriber.next(HTTPResponses.OK);
          } else {
            subscriber.next(HTTPResponses.KO);
            // Send analytics
            // GoogleTagManagerService.getInstance().pushGenericError('In questo momento il sito non è disponibile.',
            //     response.status !== undefined ? response.status.toString() : '-1000',
            //     response.statusText !== undefined ? response.statusText : 'Generic error'
            // );
          }
        }, (error) => {
          subscriber.error(error);
          // Send analytics
          // GoogleTagManagerService.getInstance().pushGenericError('In questo momento il sito non è disponibile.',
          //     error.status !== undefined ? error.status.toString() : '-1000',
          //     error.statusText !== undefined ? error.statusText : 'Generic error'
          // );
        });
      });
    }
  };

  getAppDetails(appId: string): Observable<IApplicationDetailDto> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().getAppDetails(appId);
    } else {
      // @ts-ignore
      let url = this.config.baseApi + this.config.endpoints.getAppDetails + appId;
      return new Observable((subscriber: Subscriber<IApplicationDetailDto>) => {
        httpRestClient.get(url).subscribe((response) => {
          if (response.status === 200) {
            let data = response.data;
            subscriber.next(data)
          } else {
            subscriber.error(response);
            // Send analytics
            GoogleTagManagerService.getInstance().pushGenericError('In questo momento il sito non è disponibile.',
              response.status !== undefined ? response.status.toString() : '-1000',
              response.statusText !== undefined ? response.statusText : 'Generic error'
            );
          }
        }, (error) => {
          subscriber.error(error);
          // Send analytics
          GoogleTagManagerService.getInstance().pushGenericError('In questo momento il sito non è disponibile.',
            error.status !== undefined ? error.status.toString() : '-1000',
            error.statusText !== undefined ? error.statusText : 'Generic error'
          );
        });
      });
    }
  }

  uploadCertificate(request: any): Observable<HTTPResponses> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().uploadCertificate(request);
    } else {
      // @ts-ignore
      let url = this.config.baseApi + this.config.endpoints.uploadCertificate;
      return new Observable((subscriber: Subscriber<HTTPResponses>) => {
        httpRestClient.post(url, request).subscribe((response) => {
          if (response.status === 200) {
            let data = response.data;
            subscriber.next(data)
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }

  userLogin(): Observable<HTTPResponses> {
    // @ts-ignore
    if (this.config.mockData) {
      return MockApi.getInstance().userLogin();
    } else {
      // @ts-ignore
      let url = this.config.baseApi + this.config.endpoints.userLogin;
      return new Observable((subscriber: Subscriber<HTTPResponses>) => {
        httpRestClient.post(url, {}).subscribe((response) => {
          if (response.status === 200) {
            let data = response.data;
            subscriber.next(data)
          } else {
            subscriber.error(response);
          }
        }, (error) => {
          subscriber.error(error);
        });
      });
    }
  }
}
